import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  viboOverlayWrapper: {
    '& > .rc-menu, & > .clickAwayListener > .rc-menu': {
      margin: '0',
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '20px',
      padding: '0',
      color: 'var(--text-primary)',
      overflow: 'hidden',
      backgroundColor: 'var(--background-dropDown)',

      '& > .rc-menu-item, & div > .rc-menu-item': {
        padding: '6px 10px',
        color: 'var(--text-primary)',

        '&:not(.rc-menu-item-disabled):hover': {
          color: 'var(--text-primary)',
          backgroundColor: 'var(--button-active)',

          '&, & .menuItemContent > .viboIcon': {
            '&, &:before': {
              color: 'var(--background-paper)',
            },
          },
        },

        '&:first-child': {
          ...mixins.roundedTop,
        },

        '&:last-child': {
          ...mixins.roundedBottom,
        },

        '& > .menuItemContent, & .action': {
          width: '100%',
          gap: '4px',

          '& > .viboIcon': {
            '&.viboIconSVG': {
              width: '14px',
              height: '14px',

              '@media screen and (min-width: 1441px)': {
                width: '16px',
                height: '16px',
              },
            },
          },

          '@media screen and (min-width: 1441px)': {
            gap: '6px',
          },
        },

        '&:not(.rc-menu-item-disabled)': {
          cursor: 'pointer',
        },

        '&.rc-menu-item-disabled': {
          color: `var(--text-disabled)!important`,
        },

        '@media screen and (min-width: 1441px)': {
          padding: '6px 12px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        fontSize: '16px',
        lineHeight: '20px',
      },
    },

    '&.blue': {
      border: `1px solid 'var(--clr-white)',`,

      '& .rc-menu-item': {
        backgroundColor: 'var(--primary-main)',
        color: 'var(--clr-white)',

        '&:hover': {
          backgroundColor: `var(--button-active)!important`,
          color: 'var(--clr-white)',
        },
      },
    },
  },

  viboToggleDropdown: {
    backgroundColor: 'transparent',
    display: 'flex',
  },
}));

export default useStyles;
